module.exports = __webpack_public_path__ + "images/judgement-969c9ffe9e3a97828955862aa212c9bd.jpg";